<template>
  <el-dialog :title="$t('addAShopMenu.add')" :visible.sync="dialogVisible" width="70%">
    <el-form ref="form" :model="addAShopMenuInfo" label-width="120px">
      <el-form-item :label="$t('addAShopMenu.menuName')" prop="hktName"
        :rules="[{ required: true, message: $t('addAShopMenu.menuNameRequired') }]">
        <el-input v-model="addAShopMenuInfo.hktName" :placeholder="$t('addAShopMenu.inputMenuName')" />
      </el-form-item>
      <el-form-item :label="$t('addAShopMenu.logo')" prop="hktIcon"
        :rules="[{ required: true, message: $t('addAShopMenu.logoRequired') }]">
        <upload-image ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
      </el-form-item>
      <el-form-item :label="$t('addAShopMenu.menuDesc')" prop="hktDesc">
        <el-input v-model="addAShopMenuInfo.hktDesc" :placeholder="$t('addAShopMenu.inputMenuDesc')" />
      </el-form-item>
      <el-form-item :label="$t('addAShopMenu.label')" prop="label">
        <el-input v-model="addAShopMenuInfo.label" :placeholder="$t('addAShopMenu.inputLabel')" />
      </el-form-item>
      <el-form-item :label="$t('addAShopMenu.selectShop')" prop="shopId"
        :rules="[{ required: true, message: $t('addAShopMenu.shopRequired') }]">
        <el-select v-model="addAShopMenuInfo.shopId" :placeholder="$t('addAShopMenu.selectShop')" style="width:100%">
          <el-option :label="$t('addAShopMenu.selectShop')" value="" />
          <el-option v-for="shop in addAShopMenuInfo.shops" :key="shop.shopId" :label="shop.shopName"
            :value="shop.shopId" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addAShopMenu.sort')" prop="seq"
        :rules="[{ required: true, message: $t('addAShopMenu.sortRequired') }]">
        <el-input v-model="addAShopMenuInfo.seq" :placeholder="$t('addAShopMenu.inputSort')" />
      </el-form-item>
      <el-form-item :label="$t('addAShopMenu.isShow')" prop="isShow"
        :rules="[{ required: true, message: $t('addAShopMenu.showStatusRequired') }]">
        <el-select v-model="addAShopMenuInfo.isShow" :placeholder="$t('addAShopMenu.selectShowStatus')"
          style="width:100%">
          <el-option :label="$t('addAShopMenu.yes')" value="Y" />
          <el-option :label="$t('addAShopMenu.no')" value="N" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveAddAShopMenuInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveProductMenu, queryShopsByAdmin } from '@/api/admin/shopProductType/shopProductTypeApi'
import UploadImage from '@/components/system/UploadImage'

export default {
  name: 'AddAShopMenu',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      addAShopMenuInfo: {
        hktId: '',
        hktName: '',
        hktIcon: '',
        hktDesc: '',
        label: '',
        seq: '',
        url: '',
        skipType: 'S',
        isShow: '',
        typeCd: '2002',
        shopId: '',
        shops: []
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.loadShops()
      })
    },
    async loadShops() {
      try {
        const res = await queryShopsByAdmin({ page: 1, row: 100 })
        this.addAShopMenuInfo.shops = res.data
      } catch (error) {
        console.error(error)
      }
    },
    handleUploadImage(photos) {
      this.addAShopMenuInfo.hktIcon = photos && photos.length > 0 ? photos[0] : ''
    },
    async saveAddAShopMenuInfo() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        this.addAShopMenuInfo.url = `/pages/cate/cate?shopId=${this.addAShopMenuInfo.shopId}`

        await saveProductMenu(this.addAShopMenuInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>